import { XbEnvironment, XbLogger, xbLoggerFactory } from "@amzn/xb-lite";

export type { XbEnvironment, XbLogger };

export type XbLoggingSetup = {
  /** Must exactly match (case-sensitive) the xbAppName in xb-lite-applications.json (ExperienceBridge package). */
  appName: string;
  environment: XbEnvironment;
};

const FALLBACK_XB_APP_NAME = "PUFrontend";

let xbLoggingSetup: XbLoggingSetup | undefined;

export const setupXbLogging = (setup: XbLoggingSetup): void => {
  xbLoggingSetup = setup;
};

/** One logger per page with a distinct componentName. Before setupXbLogging runs, loggers log to the console. */
export const createXbLogger = (componentName: string): XbLogger => {
  const appName = xbLoggingSetup?.appName ?? FALLBACK_XB_APP_NAME;

  return xbLoggerFactory({
    environment: xbLoggingSetup?.environment ?? "local",
    attribution: {
      appName,
      serviceName: appName,
      componentName,
    },
  });
};
